exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vaccine-section[data-v-334c03da] {\n  font-size: 90%;\n}\n.nav-tabs > a.nav-item [data-v-334c03da], a.active[data-v-334c03da]:after {\n  display: block;\n  padding: 0;\n  height: 4px;\n  background-color: #00ACC1;\n  content: ' ';\n  width: 100%;\n  margin: 0 auto;\n  margin-top: 13px;\n}\n.nav-tabs > a.nav-item[data-v-334c03da] {\n  background: none;\n  border: 0;\n  padding: 0;\n}\n.nav-tabs > a.nav-item[data-v-334c03da] {\n  border-bottom: 1px solid #DDD;\n}\n@media (max-width: 768px) {\n.nav-justified > li[data-v-334c03da] {\n    display: table-cell;\n    width: 1%;\n}\n.nav-justified > li > a[data-v-334c03da] {\n    border-bottom: 1px solid #DDD;\n    border-radius: 0;\n    margin-bottom: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-334c03da","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/Index.vue
// module id = 1963
// module chunks = 0